'use client'

import { Icon } from '@/ui/icons/icon/Icon'
import { toLoginPage } from '../../services/account.routing'

import { Link } from '@/ui/links/link/Link.client'

type EmailLinkProps = {
  email: string
  withIcon?: boolean
}

export function EmailLink({ email, withIcon = true }: EmailLinkProps) {
  return (
    // variant="free" (not a button-style variant) because ButtonContent's .btn-text truncates to one line
    <Link
      variant="free"
      underlined="invert"
      bold
      href={toLoginPage()}
      className="self-start"
      icon={withIcon ? <Icon.SquarePen className="shrink-0" /> : undefined}
    >
      <span className="line-clamp-2 break-all">{email}</span>
    </Link>
  )
}
